<app-header (clickHome)="onClickGreeting($event)"></app-header>

<div class="container" (scroll)="onScrollTop($event)">

  <div class="wrapper">

    <aside class="rope"></aside>

    <section class="main">

      <div class="inner wrap">

        <div #mainIntroBox
             class="main-intro-box">

          <div (click)="onClickGreeting($event)">
            <div class="subject-box">
              {{ greeting?.title }}
              <img [ngClass]="{'fade-out': !(showHandArrow$ | async)}"
                   src="assets/img/img-hand-arrow.gif"
                   class="arrow"
                   alt="화살표">
            </div>
            <div *ngIf="greeting?.message"
                 class="sub-box">{{ greeting?.message }}</div>
          </div>

          <app-search-box [keyword]="keyword"
                          [placeholder]="placeholder"
                          [showHistoryKeyword]="false"
                          [keyHistoryKeyword]="HISTORY_KEY_SEARCH_TOTAL"
                          [top]="scrollTop"
                          (search)="onSearch($event)"></app-search-box>

        </div>
        <div class="main-menu-box">
          <img src="assets/img/img_main_menu.png" alt="이미지">
          <a class="menu-btn-box item5"
             [routerLink]="['/dialect']">
            <div>모두<br/>우리말</div>
          </a>
          <a class="menu-btn-box item2"
             [routerLink]="['/word', LIST_TYPE.SERVER]"><span class="biggest">단어<span class="size-70">와</span></span>
            <span class="big2">예문</span></a>
          <a class="menu-btn-box item3"
             [routerLink]="['/homonym']">
          <div>같은 글자<span class="size-70">&nbsp;,</span><br/>다른 소리</div>
          </a>
          <a class="menu-btn-box item8"
             [routerLink]="['/proverb', LIST_TYPE.SERVER]">
            <span class="big1">속담</span>
          </a>
          <a class="menu-btn-box item6"
             [routerLink]="['/movie-collect', LIST_TYPE.SERVER]"><span class="big1">동영상</span>모아 보기</a>
          <a class="menu-btn-box item1" [routerLink]="['/saseung', LIST_TYPE.SERVER]"><span class="big2">사 성<span class="hanja-size">四聲</span><br/><span class="biggest">옥편</span></span></a>

          <!-- 준비 중 메뉴 활성화 시: routerLink 추가하면 (click) 핸들러 제거할 것 -->
          <a class="menu-btn-box item7"
             [routerLink]="['/sajaseungeo', LIST_TYPE.SERVER]"><div><span class="big1">사 자 성어</span><br/><span class="hanja-size">四字成語</span></div></a>

          <a class="menu-btn-box item4"
             [routerLink]="['/example', LIST_TYPE.SERVER]">
            <span class="big">문장</span>
            <span class="biggest">듣기</span>
          </a>
        </div>


      </div>


      <div #boyGirl
           class="boy_girl"></div>
      <div #bushes
           class="bush"></div>
    </section>



  </div>

  <app-common-popups></app-common-popups>

</div>
<app-footer></app-footer>
